<div
  appClickComponent
  [dataComponent]= component()
  appPosition [position]="
  {
    top: component().properties.position.y,
    left: component().properties.position.x
   }"
  [ngStyle]="{
        'fontSize.px': component().properties.fontSize,
        'background-color':component().properties.background ?? 'gray',
        'color': component().properties.colorText,
        'width.px':component().properties.size.width ,
        'height.px':component().properties.size.height ,
        'border-radius.px':component().properties.cornerRadius,
        }"
  class="flex w-full h-full"
  [ngClass]="getAlignmentText(component().properties.textAlignment)"

>
  <span class="w-fit h-fit">{{ component().properties.text ?? 'Botón' }}</span>
</div>
